import React, { useState } from "react";
import axios from "axios";
import { onSendNotification } from "../../redux/homeAction";
import { useDispatch } from "react-redux";

const NotificationForm = () => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!title || !message) {
      alert("Please fill both Title and Message!");
      return;
    }

    setLoading(true);
    try {
      const data = { title: title, message: message };
      dispatch(onSendNotification(data, setLoading));
      alert(`Notification sent to all users!`);
      setTitle("");
      setMessage("");
    } catch (err) {
      console.error(err);
      alert("Failed to send notification");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-sm p-4">
        <h3 className="card-title mb-4">Send Push Notification (All Users)</h3>

        <div className="mb-3">
          <label className="form-label">Title</label>
          <input
            className="form-control"
            placeholder="Enter notification title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Message</label>
          <textarea
            className="form-control"
            placeholder="Enter notification message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={4}
          />
        </div>

        <button
          className="btn btn-primary"
          onClick={handleSend}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send Notification to All Users"}
        </button>
      </div>
    </div>
  );
};

export default NotificationForm;
